import { Component } from '@angular/core';
import { ProjectDocumentsComponent } from '../project.documents.component';

@Component({
  selector: 'app-project-documents-mobile',
  templateUrl: './project-documents-mobile.component.html',
  styleUrls: ['./project-documents-mobile.component.scss']
})
export class ProjectDocumentsMobileComponent  extends ProjectDocumentsComponent  {
}
